module.exports = __webpack_public_path__ + "img/Mexican.59cf1330.svg";